module.exports = __webpack_public_path__ + "static/media/SD__CI_NUEVA_VF.5f8f3ce9.png";